import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
/*
const firebaseConfig = {
  apiKey: "AIzaSyB4352BamgO1hJ-H52XMi-ZsqkQwlvF_Zw",
  authDomain: "navy-dxb.firebaseapp.com",
  databaseURL: "https://navy-dxb-default-rtdb.firebaseio.com",
  projectId: "navy-dxb",
  storageBucket: "navy-dxb.appspot.com",
  messagingSenderId: "240283468531",
  appId: "1:240283468531:web:fffbc096e1650dd46e6d86",
  measurementId: "G-RX4W5YFVRD",
};*/

const firebaseConfig = {

  apiKey: "AIzaSyCQPm9vEKtPPrJl71apetjZ5XZinrENjos",
  authDomain: "metabuddy-corporate.firebaseapp.com",
  projectId: "metabuddy-corporate",
  storageBucket: "metabuddy-corporate.firebasestorage.app",
  messagingSenderId: "26152139830",
  appId: "1:26152139830:web:2a12760da41813fd602c97",
  measurementId: "G-8R2SD01JNM"

};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);

export { storage, analytics };
